import React, { useEffect, useRef, useState } from 'react';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { requestUserLogout, requestCheckAuthentication } from 'actions/users';
import { userIsAuth } from 'selectors/users';

const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;

export const IDLE_TIMEOUT_15_MINUTES = 15 * MINUTE_MS;
export const LEGACY_CHECK_AUTH_INTERVAL_15_SECONDS = 15 * SECOND_MS;
export const REDUCED_CHECK_AUTH_INTERVAL_8_MINUTES = 8 * MINUTE_MS;
export const DEV_CHECK_AUTH_INTERVAL_14_MINUTES = 14 * MINUTE_MS;

export const getCheckAuthIntervalMs = ({ useReducedPolling }) => {
  if (process.env.NODE_ENV === 'development') {
    return DEV_CHECK_AUTH_INTERVAL_14_MINUTES;
  }

  return useReducedPolling ? REDUCED_CHECK_AUTH_INTERVAL_8_MINUTES : LEGACY_CHECK_AUTH_INTERVAL_15_SECONDS;
};

export function IsIdle({ isAuth, requestCheckAuthentication: onCheckAuthentication }) {
  const idleTimerRef = useRef();
  const [isIdle, setIsIdle] = useState(false);
  const { operationalReducedCheckAuthPolling } = useFlags();

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isAuth) {
        onCheckAuthentication({ isIdle });
      }
    }, getCheckAuthIntervalMs({ useReducedPolling: operationalReducedCheckAuthPolling }));

    return () => clearInterval(intervalId);
  }, [isAuth, isIdle, onCheckAuthentication, operationalReducedCheckAuthPolling]);

  return (
    <IdleTimer ref={idleTimerRef} onActive={() => setIsIdle(false)} onIdle={() => setIsIdle(true)} timeout={IDLE_TIMEOUT_15_MINUTES} startOnLoad />
  );
}

const mapStateToProps = state => ({
  isAuth: userIsAuth(state),
});

export default connect(mapStateToProps, { requestUserLogout, requestCheckAuthentication })(IsIdle);
